import Wallet from "helpers/wallet";

// Import wallet adapters
// import {
//   PhantomWalletAdapter,
//   Coin98Adapter,
//   LedgerWalletAdapter,
//   MathWalletAdapter,
//   SlopeWalletAdapter,
//   SolletExtensionAdapter,
//   SolongWalletAdapter,
//   SolflareAdapter,
//   SolflareExtensionWalletAdapter
// } from "./adapters";

import { WalletAdapter } from '@solana/wallet-adapter-base'
import { PhantomWalletAdapter } from '@solana/wallet-adapter-phantom'
import { MathWalletWalletAdapter } from '@solana/wallet-adapter-mathwallet'
import { SolletWalletAdapter } from '@solana/wallet-adapter-sollet'
import { SolflareWalletAdapter } from '@solana/wallet-adapter-solflare'
import { Coin98WalletAdapter } from '@solana/wallet-adapter-coin98'
// import { SlopeWalletAdapter } from '@solana/wallet-adapter-slope'
import { SafePalWalletAdapter } from '@solana/wallet-adapter-safepal'
import { initWallet } from "redux/state";

const InitializeWallet = (state, dispatch) => {
  const { provider } = state;
  let wallet = null;
  switch(provider) {
    case "phantom":
      wallet = new PhantomWalletAdapter();
      break;
    case "solletExtension":;
      wallet = new SolletWalletAdapter({ provider: window.sollet });
      break;
    case "solflare":
      wallet = new SolletWalletAdapter({ provider: "https://solflare.com/access-wallet" });
      break;
    case "solflareExtension":
      wallet = new SolflareWalletAdapter();
      break;
    case "coin98":
      wallet = new Coin98WalletAdapter();
      break;
    case "math":
      wallet = new MathWalletWalletAdapter();
      break;
    case "safepal":
      wallet = new SafePalWalletAdapter();
      break;
    // case "slope":
    //   wallet = new SlopeWalletAdapter();
    //   break;
  }


  dispatch(initWallet(wallet));
};

export default InitializeWallet;
